import { h, Component } from 'preact';
import { Link } from 'preact-router';
import style from './style';

export default class Footer extends Component {
	render() {
		return (
			<footer class={style.footer}>
				<p>The Pottery, Pinmore, By Girvan, Ayrshire, KA26 0TR<br/>+44 (0)1465 841 662 | info@peinnmor.co.uk</p>
			</footer>
		);
	}
}



// WEBPACK FOOTER //
// ./components/footer/index.js